import { IonCol, IonContent, IonGrid, IonPage, IonRow, IonText } from "@ionic/react";

const Security: React.FC = () => {

    const name = "Your Swissdonations security";

    return (
        <IonPage className="viewContainer">
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>
                                <h1>Security</h1>
                            </IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
        </IonPage>)
}

export default Security;

